<template>
    <div class="info-fenxiang">
        <van-swipe class="swiper" @change="getPosterUrl">
            <van-swipe-item v-for="(item,index) in tempFilePathList" :key="index" style="text-align:center;overflow-y:auto">
                <van-image
                        fit="contain"
                        :src="item.img"
                        class="temp-file-img"
                />
            </van-swipe-item>
        </van-swipe>

        <div class="info-fenxiang-footer">
            <span class="info-fenxiang-txt">二维码为个人分享专用二维码</span>
            <div class="flex share_btn">
                <div class="flex__item" @click="is_show_share = true">
                    <img src="../../assets/icon/weixin.png" style="width: 32px;"/>
                    <div>微信</div>
                </div>
                <div class="flex__item"  @click="domGenerateImage">
                    <img src="../../assets/icon/tupian.png" style="width: 32px;"/>
                    <div>保存本地</div>
                </div>
            </div>
        </div>


        <share :is_show_share="is_show_share" v-on:hideShare="hideShare"></share>

        <canvas id="shareCustom" style="position: fixed;left:99999px;"></canvas>
    </div>
</template>

<script>
    import { Image as VanImage } from 'vant';
    import { Swipe, SwipeItem,ShareSheet,Toast} from 'vant';
    import share from '../../components/common/share';
    export default {
        name: "info",
        components:{
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            [VanImage.name]:VanImage,
            [ShareSheet.name]:ShareSheet,
            Toast,share
        },
        data(){
            return {
                options:[
                    {
                        name:'发送给朋友',
                        icon:'https://o-yzx.bysjy.com.cn/common/zf.png'
                    },
                    {
                        name:'分享到朋友圈',
                        icon:'https://o-yzx.bysjy.com.cn/common/pyq.png'
                    },
                    {
                        name:'保存本地',
                        icon:'https://o-yzx.bysjy.com.cn/common/tupian.png'
                    },
                ],
                is_show_share:false,
                course_id:'',
                url:'',
                path:'',
                text:'',
                photoPath:'',
                miniPath:'',
                tempFilePathList:[],
                coverPath:'',
                custom_poster:{
                    width:375,
                    height:667
                }
            }
        },
        mounted() {
            if(navigator.userAgent.toLowerCase().indexOf('windowswechat')>-1){
                this.text= '右键复制图片，分享给好友'
            }else{
                this.text= '长按图片保存到相册'
            }
            this.course_id=this.util.getQueryStr('course_id');
            this.url = this.util.getQueryStr('url');

            if(!this.util.isUserLogin()) {
                return;
            }

            if (this.util.globalData.user.get() == '') {
                this.util.server.mini_user.info({
                    callback: res => {
                        this.util.globalData.user.set(res.data);
                        this.bindInit();
                    }
                });
            }else{
                this.bindInit();
            }
            this.bindWeiXin();

            //上报分享主责人
            this.savePosterUser();
        },
        methods:{

            bindWeiXin:function(){
                var _self=this;
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.params.course_info.name,
                        desc: _that.params.course_info.name,
                        link: _that.path,
                        imgUrl: _that.params.course_info.cover
                    });
                });
            },
            hideShare(e){
                this.is_show_share = e;
            },
            bindInit:function(){

                this.user = this.util.globalData.user.get().user_name;
                this.photoPath = this.util.globalData.user.get().photo;

                var _self=this;
                this.util.server.yzx.get_poster({
                    data: {
                        poster_id: _self.course_id,
                    },
                    callback: (res => {
                        if(res.code==-1){
                            return this.util.showToast({
                                message:res.msg
                            });
                        }

                        var data = res.data;
                        for(var i =0;i<data.images.length;i++){
                            data.images[i] =  data.images[i].replace('http://yun-yzx.oss-cn-shenzhen.aliyuncs.com/',this.util.ossYzxUrl);
                        }
                        data.course_info.cover =  data.course_info.cover.replace('http://yun-yzx.oss-cn-shenzhen.aliyuncs.com/',this.util.ossYzxUrl);
                        this.params = data;
                        this.MiniQrCode();
                    })
                });
            },
            getPosterUrl:function(index){
                this.posterUrl = index;

                //TODO 新版自定义海报
                if(this.params.design_datas.length>0){
                    if (this.tempFilePathList[index].img.indexOf('data:image') == -1) {
                        this.customDrawCanvasImage(this.tempFilePathList[index].img, index);
                    }
                }
            },
            //生成页面二维码
            MiniQrCode:function(){
                var _self=this;
                var url = decodeURIComponent(this.url);
                if(url.indexOf('?')>=0){
                    url +='&u_id='+this.util.getUserId.get()+'&p_id='+this.course_id;
                }else{
                    url +='?u_id='+this.util.getUserId.get()+'&p_id='+this.course_id;
                }
                this.path = url;
                this.util.server.yzx.get_share_h5_url({
                    data: {
                        url: url
                    },
                    callback: (res => {
                        //小程序二维码本地路径
                        if (!!res.data) {
                            this.miniPath = res.data;
                            _self.getCoverPath();
                        }else{
                            this.util.showToast({
                                message:res.msg
                            });
                        }
                    })
                });
            },

            getCoverPath:function(){
                var _self=this;

                this.coverPath = _self.params.course_info.cover;

                //TODO 新版自定义海报
                if(_self.params.design_datas instanceof Array){
                    for (var i=0;i<_self.params.design_datas.length;i++){
                        if(_self.params.design_datas[i].images.url==''){
                            return
                        }
                        _self.tempFilePathList[i]=[];
                        _self.tempFilePathList[i]['img']='';

                        this.tempFilePathList[i].img=_self.params.design_datas[i].images.url;

                        this.$forceUpdate();

                        if(i==0){
                            _self.customDrawCanvasImage(_self.params.design_datas[i].images.url, i);
                        }
                    }
                }
            },

            //自定义海报样式
            customCanvas:function(res,index){
                var _self=this;

                var mini_url = _self.miniPath;
                var user_logo=_self.photoPath;
                var user_name =_self.user;
                var data = _self.params.design_datas[index];
                var scale = 2;

                //背景图片
                var backgroundImg=new Image();
                backgroundImg.crossOrigin="anonymous"; //关键
                backgroundImg.src= res;
                backgroundImg.onload=function(){
                    var canvas = document.getElementById("shareCustom");
                    canvas.width=data.images.w * scale;
                    canvas.height = data.images.h * scale;
                    canvas.style.width = data.images.w;
                    canvas.style.height = data.images.h;

                    var ctx = canvas.getContext("2d")

                    //画布高宽
                    ctx.fillRect(0, 0, data.images.w* scale, data.images.h* scale);
                    ctx.drawImage(this, 0, 0, data.images.w* scale,  data.images.h* scale);

                    //绘制二维码
                    if(data.mini_url.is_show){
                        var miniUrl=new Image();
                        miniUrl.crossOrigin="anonymous"; //关键
                        miniUrl.src= mini_url;
                        miniUrl.onload=function(){
                            ctx.drawImage(this,data.mini_url.x* scale ,data.mini_url.y* scale , data.mini_url.w* scale, data.mini_url.h* scale);
                        };
                    }

                    setTimeout(function () {
                        //绘制头像
                        if(data.user_logo.is_show) {

                            var userLogo=new Image();
                            userLogo.crossOrigin="anonymous"; //关键
                            userLogo.src= user_logo;
                            userLogo.onload=function(){
                                //绘制圆形头像
                                ctx.arc(data.user_logo.w / 2 + data.user_logo.x, data.user_logo.h / 2 + data.user_logo.y, 36 / 2, 0, Math.PI * 2);
                                ctx.clip();
                                ctx.drawImage(this, data.user_logo.x, data.user_logo.y, data.user_logo.w, data.user_logo.h);
                            };
                        }

                        //绘制昵称
                        if(data.user_name.is_show){
                            ctx.fillStyle = data.user_name.fontColor;
                            ctx.font = 'normal '+data.user_name.fontWeight+' '+data.user_name.fontSize* scale+'px sans-serif';
                            var nameY=data.user_name.y*1 + data.user_name.fontSize*1 + _self.getFontHeight(data.user_name.fontSize* scale);
                            ctx.fillText(user_name, data.user_name.x*1* scale,nameY*1* scale);
                        }

                        //绘制文字
                        for (var key in data){
                            if(!data[key].text || !data[key].is_show || key == 'user_name'){
                                continue;
                            }
                            if(data[key].type=='font'){
                                ctx.fillStyle = data[key].fontColor;
                                ctx.font = 'normal '+data[key].fontWeight+' '+data[key].fontSize* scale+'px sans-serif';
                                var y=data[key].y*1 + data[key].fontSize*1 + _self.getFontHeight(data[key].fontSize* scale);
                                ctx.fillText(data[key].text, data[key].x*1* scale, y*1* scale);
                            }
                        }

                        ctx.scale(scale,scale);

                        _self.util.showToast({
                            message: '正在加载海报模板...',
                            duration:0
                        });

                        setTimeout(function () {
                            _self.tempFilePathList[index].img =document.getElementById("shareCustom").toDataURL("image/png");
                            _self.$forceUpdate();

                            _self.$toast.clear();
                        },1000)
                    },1000)
                };

            },
            getFontHeight:function(size){
                //初始化字体高度是4
                //字体大小从10开始，每增加4，字体的高度就加1。
                //示例 10=>4 12=>4,14=>5,16=>5,18=>6,20=>6
                var init_height=4;
                var font_differ = size-10;
                init_height +=Math.floor(font_differ/4);
                return init_height
            },
            //绘制自定义画布图片
            customDrawCanvasImage:function(posterUrl,index){

                var _self = this;

                this.util.showToast({
                    message: '正在初始化海报模板...',
                    duration:0
                });

                _self.customCanvas(posterUrl,index);
            },
            //页面生成图片
            domGenerateImage: function() {
                var _self = this;

                this.util.showToast({
                    message:this.text
                })

                // var posterUrl = this.posterUrl || 0;
                //
                // posterUrl = this.tempFilePathList[posterUrl].img;
                //
                // Toast.loading({
                //     duration: 0,
                //     message: '正在保存...',
                //     forbidClick: true
                // });

                // 保存图片到本地
                // _self.downloadFile(posterUrl);

            },
            //保存图片到本地
            downloadFile: function(posterUrl) {
                var aLink = document.createElement('a');
                var blob = this.util.base64Img2Blob(posterUrl); //new Blob([content]);
                //var evt = document.createEvent("HTMLEvents");
                //evt.initEvent("click", false, false); //initEvent 不加后两个参数在FF下会报错
                aLink.download = '微信图片_'+this.util.currentTime()+'.png';
                aLink.href = URL.createObjectURL(blob);
                aLink.click();
                console.log(aLink)
                Toast.clear();
                this.util.showToast({
                    title: '保存成功',
                    icon: 'none'
                });
            },
            //保存分享主责人
            savePosterUser:function(){
                this.util.server.event.event({
                    data: {
                        message:{
                            poster_id:this.course_id,
                            user_id:this.util.getUserId.get(),
                            p_user_id:'',
                            log_id:this.util.random(32)
                        },
                        code:10020,
                    },
                    callback: (res => {})
                });
            },
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .page{
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
    .info-fenxiang{
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .info-fenxiang-content{
        height: 70%;
    }
    .info-fenxiang-footer{
        position: fixed;
        bottom: 0;
        height: 20%;
        text-align: center;
        padding: 10px;
        width: 100%;
        background-color: #fff;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .info-fenxiang-txt{
        color: #999999;
    }
    .share_btn {
        background: #fff;
        border-radius: 4px;
        margin: 20px 0;
        text-align: center;
    }

    .share_btn button {
        background: #fff;
        border: 1px solid #fff;
        line-height: 1.2;
    }

    .share_btn button::after {
        border: none;
    }

    .share_btn view {
        font-size: 12px;
    }

    .share_btn image {
        width: 32px;
        height: 32px;
    }
    .swiper{
        width:100%;
        overflow: hidden;
        margin:0 auto;
        height: 80%;
        position: fixed;
        top: 0;
    }
    .swiper >>> .van-swipe__indicator{
        background-color: #111;
    }
    .swiper >>> .van-swipe__indicator--active{
        background-color: #1989fa;
    }
    .swiper-txt{
        width: 100%;
        overflow: hidden;
        text-align: center;
        padding: 10px;
        vertical-align: middle;
        line-height: 5%;
        display: inline-block;
        box-sizing: border-box;
        -o-box-sizing: border-box;
        -ms-box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }
    .swiper-txt .share-txt {
        width: 75%;
        height: 100%;
        float: left;
        overflow: hidden;
    }
    .swiper-txt .share-mini {
        width: 20%;
        height: 100%;
        float: right;
    }
    .share-txt .txt1{
        font-size: 13px;
    }
    .share-txt .txt2{
        margin-top: 10px;
        font-size: 12px;
    }
    .temp-file-img{
        width: 300px;
        height: 360px;
        margin-top: 10%;
    }
    .swiper-img{
        /*position: absolute;*/
        /*width: 65vw;*/
        /*height: 72vh;*/
        transform: scale(0.6);
        width:375px;
        height:667px;
        /*transform-origin: 0 0;*/
    }
    .swiper-img .swiper-content{
        background-color: #ffffff;
        width: 90%;
        vertical-align: middle;
        position: absolute;
        left: 5%;
        bottom: 7%;
        padding: 15px 0;
        border-radius: 5px;
        color: #222223;
    }
    .swiper-img .swiper-head{
        text-align: center;
        width: 100%;
        height: 80%;
    }
    .swiper-content .swiper-content-title{
        padding: 10px 10px 0 10px;
        font-size: 18px;
    }
    .swiper-content .swiper-content-name{
        display: inline-block;
        position: relative;
    }
    .swiper-content-name .swiper-content-name-top{
        font-size: 18px;
        font-weight: bold;
        position: relative;
        z-index: 2;
    }
    .swiper-content .swiper-content-name:after{
        content: '';
        position: absolute;
        width: 100%;
        height: 5px;
        background:rgba(241,144,0,1);
        bottom: 0;
        left: 0;
        border-radius: 3px;
    }
    .swiper-content .swiper-content-slogan{
        padding: 10px 10px 0 10px;
    }
    .swiper-content .swiper-content-time{
        padding: 10px;
        font-weight: bold;
    }
    .swiper-content .swiper-content-copy-writing{
        padding: 10px 10px 0 10px;
    }
    .swiper-content .swiper-content-guide{
        padding: 20px;
        font-size: 18px;
    }
    .swiper-content .swiper-content-mini{
        padding: 10px 20px;
    }
    .swiper-content-img{
        width:90%;
        margin:0 auto;
        border-radius: 5px;
    }
    .swiper-content-mini .mini-photo{
        height: 50px;
        width:50px;
        border-radius: 50%;
        float: left;
    }
    .mini-text{
        width: 60%;
        float: left;
        text-align: left;
        margin-left: 5px;
    }
    .mini-text .mini-text-user{
        font-size:12px;
    }
    .mini-text .mini-text-slogan{
        font-size:12px;
        font-weight:bold;
    }
    .mini-text .mini-text-guide{
        font-size:10px;
    }
    .mini-logo{
        width: 17%;
        height: 50px;
        float: right;
    }
</style>
